import { AppInstanceFull } from '@wpp-open/core'

import { facadeApi } from 'api'

export interface Params {
  id: string
}

export const fetchAppInstance = ({ id }: Params) => facadeApi.get<AppInstanceFull>(`/app-instances/${id}`)
